module.exports = __webpack_public_path__ + "img/expedia.44c17e9a.svg";